import { createFileRoute } from "@tanstack/react-router"
import { BAKERY_ADDRESS, SITE_NAME } from "@/lib/constants/site"
import { SITE_URL } from "@/lib/constants/site-url"
import { TOAST_MENU_MEDIA } from "@/lib/data/toast-menu-media"
import MenuPage from "@/pages/menu"

const OG_IMAGE = TOAST_MENU_MEDIA.banner
const MENU_SECTION_NAMES = [
  "Brunch",
  "Rice Bowls",
  "Quick Bites",
  "Pastries",
  "Specialty Lattes",
  "Matcha",
  "Coffee",
  "Tea and Juice",
]

export const Route = createFileRoute("/$countryCode/menu")({
  head: () => {
    const title = "Dine-In Menu | +Bake Cafe - Asian-Fusion Bakery & Cafe"
    const description =
      "The +Bake Cafe menu: brunch plates, rice bowls, salt bread, cookies, and specialty lattes in Rancho Cucamonga, CA."
    const canonical = `${SITE_URL}/menu`

    const breadcrumbSchema = {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
        { "@type": "ListItem", position: 2, name: "Menu", item: canonical },
      ],
    }

    const menuSchema = {
      "@type": "Menu",
      name: `${SITE_NAME} Menu`,
      url: canonical,
      inLanguage: "en-US",
      provider: {
        "@type": "Bakery",
        name: SITE_NAME,
        address: {
          "@type": "PostalAddress",
          streetAddress: BAKERY_ADDRESS.street,
          addressLocality: BAKERY_ADDRESS.city,
          addressRegion: BAKERY_ADDRESS.region,
          postalCode: BAKERY_ADDRESS.postalCode,
          addressCountry: BAKERY_ADDRESS.country,
        },
      },
      hasMenuSection: MENU_SECTION_NAMES.map((name) => ({
        "@type": "MenuSection",
        name,
      })),
    }

    const schemaGraph = {
      "@context": "https://schema.org",
      "@graph": [breadcrumbSchema, menuSchema],
    }

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonical },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:image:width", content: "1200" },
        { property: "og:image:height", content: "630" },
        { property: "og:site_name", content: SITE_NAME },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: canonical }],
      scripts: [
        { type: "application/ld+json", children: JSON.stringify(schemaGraph) },
      ],
    }
  },
  component: MenuPage,
})
